// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Empty(props: unknown) {
    return null
}
